"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationFileRoutes = void 0;
var ApplicationFileRoutes;
(function (ApplicationFileRoutes) {
    ApplicationFileRoutes["BasePrefix"] = "application-files";
    ApplicationFileRoutes["ById"] = ":applicationFileId";
    ApplicationFileRoutes["AllByApplicationId"] = "all/:applicationId";
})(ApplicationFileRoutes = exports.ApplicationFileRoutes || (exports.ApplicationFileRoutes = {}));
